const ourFundsList = [
  {
    title: "Indian Equity",
    link: `/mutual-funds/category/indian-equity`,
    image: "/mutualfund/assets/images/header/indian_equity.svg",
    isFundCategory: true,
  },
  {
    title: "International Equity",
    link: `/mutual-funds/category/international-equity`,
    image: "/mutualfund/assets/images/header/international_equity.svg",
    isFundCategory: true,
  },
  {
    title: "Hybrid & Balanced",
    link: `/mutual-funds/category/hybrid-balanced`,
    image: "/mutualfund/assets/images/header/hybrid_and_balanced.svg",
    isFundCategory: true,
  },
  {
    title: "Multi Asset",
    link: `/mutual-funds/category/multi-asset`,
    image: "/mutualfund/assets/images/header/multi_asset.svg",
    isFundCategory: true,
  },
  {
    title: "Commodity",
    link: `/mutual-funds/category/commodity`,
    image: "/mutualfund/assets/images/header/commodity.svg",
    isFundCategory: true,
  },
  {
    title: "Debt & Liquid",
    link: `/mutual-funds/category/debt-liquid`,
    image: "/mutualfund/assets/images/header/debt_and_liquid.svg",
    isFundCategory: true,
  },
]

const fundTypes = [
  {
    id: "Index",
    title: "Index Funds",
    link: `/index-fund`,
    image: "/mutualfund/assets/images/header/index_fund.svg",
  },
  {
    id: "ETFs",
    title: "ETFs",
    link: `/etf`,
    image: "/mutualfund/assets/images/header/etf.svg",
  }
]

const investorEducationList = [
  {
    title: "Blogs",
    link: `/investor-education/category/blog/`
  },
  {
    title: "Videos",
    link: `/investor-education/category/videos/`
  },
  {
    title: "5 Keys of Investing",
    link: `/investor-education/category/5-keys-of-investing/`
  },
  {
    title: "Wealth Creation Thoughts",
    link: `/investor-education/wealth-creation-thoughts`
  }
]

const toolsAndCalculatorsList = [
  {
    title: "SIP Returns Calculator",
    link: `/sip-calculator`
  },
  {
    title: "Compare Portfolio",
    link: `/tools/compare-portfolio`
  },
  {
    title: "Compounding Magic",
    link: `/tools/compounding-magic`
  },
]

const newsAndInsights = [
  {
    title: "Blogs",
    link: "https://www.motilaloswalamc.com/insights/"
  },
  {
    title: "Press-Release",
    link: `/Media-Room/Press-Release`
  },
  {
    title: "Interviews",
    link: `/Media-Room/Press-Release`
  },
  {
    title: "News",
    link: `/Media-Room/Press-Release`
  }
]

const importantLinks = [
  {
    title: "Downloads",
    link: "/download/forms"
  },
  {
    title: "NAV & TER",
    link: `/nav/latest-nav`,
  },
  {
    title: "Investor Charter",
    link: `${process.env.REACT_APP_MOTILAL_MF_MODULE_URL}CMS/assets/uploads/files/MF-Investor-Charter.pdf`,
    external: true
  }, {
    title: "Account Statement",
    link: "/reporthub",
  },
  {
    title: "Contact Us",
    link: "/contact-us",
  }
]

const distributorServices = [
  {
    title: "Become A Distributor",
    link: "https://digipartner.motilaloswalamc.com/login",
    image: "/mutualfund/assets/images/header/become-distributor_new.svg"
  },
  {
    title: "Why Choose Us",
    link: `${process.env.REACT_APP_PARTNER_MODULE_URL}`,
    image: "/mutualfund/assets/images/header/why_choose_us_new.svg"
  },
  {
    title: "Downloads",
    link: `/download/forms`,
    image: "/mutualfund/assets/images/header/downloads_new.svg"
  },
  {
    title: "FAQs",
    link: `${process.env.REACT_APP_PARTNER_MODULE_URL}faq`,
    image: "/mutualfund/assets/images/header/faq_new.svg"
  }
]

const mobileHeaderLinks = {
  "Our Funds": [
    {
      title: "Fund Categories",
      isHeading: true
    },
    ...ourFundsList,
    {
      title: "Fund Types", // Using just as a flag
      isHeading: true
    },
    {
      title: "Popular Funds", // Using just as a flag
      isHeading: true
    },
  ],
  "Investor Services": [
    {
      title: "Investor Education",
      isHeading: true
    },
    ...investorEducationList,
    {
      title: "Tools & Calculators",
      isHeading: true
    },
    ...toolsAndCalculatorsList,
    {
      title: "News & Insights",
      isHeading: true
    },
    ...newsAndInsights,
    {
      title: "Important Links",
      isHeading: true
    },
  ],
  "Partner Services": [
    ...distributorServices,
    {
      title: "Dist Important Links",
      isHeading: true
    },
  ],
}

const importantLinksPartnerServices = [
  {
    title: "Login",
    link: `${process.env.REACT_APP_PARTNER_MODULE_URL}investonline/dist`,
  },
  {
    title: "Quick Purchase",
    link: `${process.env.REACT_APP_PARTNER_MODULE_URL}v2/purchaselink`,
  },
  {
    title: "Account Statement",
    link: "/reporthub",
  },
]

export {
  ourFundsList,
  fundTypes,
  investorEducationList,
  toolsAndCalculatorsList,
  newsAndInsights,
  importantLinks,
  distributorServices,
  mobileHeaderLinks,
  importantLinksPartnerServices
}
